import React from 'react';
import MarkdownRenderer from './MarkdownRenderer';

type StyledElement = React.ReactElement<{ style?: React.CSSProperties }>;

interface MixedContentRendererProps {
    content: string | (string | React.ReactElement)[];
    isSpecial?: boolean;
}

const MixedContentRenderer: React.FC<MixedContentRendererProps> = ({
    content,
    isSpecial = false,
}) => {
    if (typeof content === 'string') {
        if (isSpecial) {
            return <>{content}</>;
        }
        return (
            <MarkdownRenderer
                content={content}
                style={{
                    margin: 0,
                    color: 'var(--rw-text-primary)',
                    maxWidth: '100%',
                    wordWrap: 'break-word',
                }}
            />
        );
    }

    // Handle mixed content array
    return (
        <div style={{ display: 'block' }}>
            {content.map((item, index) => {
                if (typeof item === 'string') {
                    if (isSpecial) {
                        // biome-ignore lint/suspicious/noArrayIndexKey: mixed content with no unique ids
                        return <span key={`span-${index}`}>{item}</span>;
                    }
                    return (
                        <MarkdownRenderer
                            // biome-ignore lint/suspicious/noArrayIndexKey: mixed content with no unique ids
                            key={`md-${index}`}
                            content={item}
                            style={{
                                margin: 0,
                                color: 'var(--rw-text-primary)',
                                maxWidth: '100%',
                                wordWrap: 'break-word',
                            }}
                        />
                    );
                }
                // Add marginLeft to button if not first element and if the element accepts style
                if (React.isValidElement(item) && index > 0) {
                    const element = item as StyledElement;
                    if (
                        element.props &&
                        typeof element.props === 'object' &&
                        'style' in element.props
                    ) {
                        return React.cloneElement(element, {
                            // biome-ignore lint/suspicious/noArrayIndexKey: mixed content with no unique ids
                            key: `elem-${index}`,
                            style: { ...(element.props.style || {}), marginLeft: 12 },
                        });
                    }
                    // biome-ignore lint/suspicious/noArrayIndexKey: mixed content with no unique ids
                    return React.cloneElement(element, { key: `elem-${index}` });
                }
                return React.isValidElement(item)
                    ? React.cloneElement(item as StyledElement, {
                          // biome-ignore lint/suspicious/noArrayIndexKey: mixed content with no unique ids
                          key: `item-${index}`,
                      })
                    : item;
            })}
        </div>
    );
};

export default MixedContentRenderer;
